import { render } from "./ExTankOrderManagement.html?vue&type=template&id=2d2dfbb8&scoped=true"
import script from "./ExTankOrderManagement.js?vue&type=script&lang=js"
export * from "./ExTankOrderManagement.js?vue&type=script&lang=js"

import "./ExTankOrderManagement.css?vue&type=style&index=0&id=2d2dfbb8&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2dfbb8"]])

export default __exports__